import {FooterTabFragment, FooterTabFragmentProps, FooterTabFragmentState} from "../../shared/FooterTabFragment";
import {Button, Grid, Typography} from "@mui/material";
import {StyledBoxColumn, StyledContainer} from "../../shared/StyledComponents";
import React from "react";
import {GameFragmentListener} from "./GameFragment";
import {GameOverResult, GameOverResultType} from "./types";
import {
  BaseApp,
  DIALOG_FLAG_DISABLE_BACKDROP_CLICK,
  DIALOG_FLAG_SHOW_CLOSE,
  DIALOG_FLAG_SHOW_DIALOG_FULLSCREEN
} from "../../shared/BaseApp";
import {PD_LG, PD_XLG, PD_XLG2} from "../../shared/dimens";
import {Game} from "../types";
import {GameCard} from "../GameCard";
import {GAMES} from "../Games";

export type GamesFragmentProps = FooterTabFragmentProps & {}

export type GamesFragmentState = FooterTabFragmentState & {
  selectedGame?: Game,
}

export class GamesFragment extends FooterTabFragment<GamesFragmentProps, GamesFragmentState> implements GameFragmentListener {

  getTitle(): string {
    return "Games";
  }

  onBoardUpdated() {
  }

  onGameEnded() {
  }

  onGameOver(result: GameOverResult, ...args) {
    switch (result.type) {
      case GameOverResultType.WON:
        BaseApp.CONTEXT.showDialog({flags: DIALOG_FLAG_DISABLE_BACKDROP_CLICK | DIALOG_FLAG_SHOW_CLOSE}, () => {
          return <StyledBoxColumn style={{padding: PD_LG}}>
            <Typography variant="h5">Congratulations!</Typography>
            <Typography>{result.resultText}</Typography>
            {result.ineligible ?
              <Typography>Because you used a hint or check tool, this game will not be counted towards your stats or
                charts.</Typography> : null}
            <Button variant="contained" onClick={() => {
              BaseApp.CONTEXT.hideAllDialogs();
              this.props.path.navigate("/stats/" + result.gameId);
            }}>View my stats</Button>
            {/*<Button variant="outlined" onClick={() => {*/}
            {/*  BaseApp.CONTEXT.hideAllDialogs();*/}
            {/*  this.props.path.navigate("/charts/" + result.gameId);*/}
            {/*}}>View charts</Button>*/}
          </StyledBoxColumn>;
        });
    }
  }

  onGameReset() {
  }

  onStatusChanged(status: string) {
  }

  renderContent(): React.ReactElement {
    return this.state.selectedGame ?
      this.state.selectedGame.render(this.props.path, this)
      : <div style={{position: "relative", flexGrow: 1, background: "black"}}>
        <img src={"/images/background.jpg"} style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          opacity: 0.5,
          filter: "blur(8px)",
          objectFit: "cover"
        }}/>
        <StyledContainer size="lg" style={{padding: PD_LG, gap: PD_XLG2}}>
          <StyledBoxColumn>
            <Typography variant="h5" style={{color: "white", padding: PD_XLG}}>Countries Quiz</Typography>
            <Grid container spacing={4}>
              {GAMES.map(game => <Grid item xs={12} sm={6} lg={4}>
                  <GameCard game={game} onClick={() => this.showGame(game)}>
                    <StyledBoxColumn style={{background: "white", padding: PD_LG}}>
                      <Typography style={{textAlign: "center", height: "2rem"}}>{game.description}</Typography>
                      <Button variant="contained">Play</Button>
                      {/*<Button variant="contained" style={{flexGrow: 1}} onClick={() => this.showGame(game)}>Play</Button>*/}
                    </StyledBoxColumn>
                  </GameCard>
                </Grid>
              )}
            </Grid>
          </StyledBoxColumn>
        </StyledContainer>
      </div>;
  }

  private showGame(game: Game) {
    BaseApp.CONTEXT.showDialog({flags: DIALOG_FLAG_SHOW_DIALOG_FULLSCREEN,}, () => game.render(this.props.path, this));
  }
}
